module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[110]475.b750fc8.woff2";